import React from "react";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";

interface DropdownHeaderProps {
  username: string;
  planLabel: string;
}

const DropdownHeader = ({ username, planLabel }: DropdownHeaderProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingBottom: "8px",
    }}
    aria-disabled="true"
  >
    <Box
      sx={{
        color: colors.neutral[100],
        fontFamily: "Outfit, sans-serif",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "22px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingRight: "12px",
      }}
    >
      {username}
    </Box>

    <Box
      sx={{
        backgroundColor: colors.dropdown.planBadgeBg,
        borderRadius: "100px",
        height: "20px",
        width: "56px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        overflow: "hidden",
      }}
    >
      <Box
        component="span"
        sx={{
          color: colors.dropdown.planBadgeText,
          fontFamily: "Outfit, sans-serif",
          fontSize: "10px",
          fontWeight: 700,
          letterSpacing: "0.8px",
          textTransform: "uppercase",
          lineHeight: "normal",
          textAlign: "center",
        }}
      >
        {planLabel}
      </Box>
    </Box>
  </Box>
);

export default DropdownHeader;
